export const orderTypes = {
    PHOTOLIST: 'photolist',
    PHOTOPACKAGE: 'photopackage',
}